var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.502C13.5 14.8827 14.8431 16.002 16.5 16.002C18.1569 16.002 19.5 14.8827 19.5 13.502C19.5 12.1212 18.1569 11.002 16.5 11.002C14.8431 11.002 13.5 12.1212 13.5 13.502ZM13.5 13.502C11.1131 13.502 8.82387 12.7118 7.13604 11.3053C5.44821 9.89873 4.5 7.99108 4.5 6.00195M4.5 6.00195C6.15685 6.00195 7.5 4.88266 7.5 3.50195C7.5 2.12124 6.15685 1.00195 4.5 1.00195C2.84315 1.00195 1.5 2.12124 1.5 3.50195C1.5 4.88266 2.84315 6.00195 4.5 6.00195ZM4.5 6.00195V16.002",
    stroke: "#646D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.d0d8113a98883c8e8f4c453c61db4a3a.svg";
export { ForwardRef as ReactComponent };